const styles = {
  headerSection: {
    position: "relative",
    display: "flex",
    top: "0",
    width: "100vw",
    height: "5em"
  },
  headerIcon: {
    padding: "1em",
    color: "rgb(106, 106, 120)",
    width: "74px",
    height: "74px"
  },
  headerBreadCrumb: {
    color: "rgb(147, 147, 162)",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    height: "74px",
    letterSpacing: "-0.5px",
    width: "232px",
    padding: "16px 0",
    textAlign: "left"
  },
  body: {
    position: "relative",
    top: "0"
  },
  titleSection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2.5em"
  },
  actionsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  title: {
    width: "640px",
    height: "57px",
    color: "rgb(29, 31, 32)",
    fontSize: "40px",
    fontFamily: "ToyotaType-Semibold",
    fontWeight: "600",
    textAlign: "center",
    letterSpacing: "-0.5px"
  },
  actions: {
    width: "17.3em",
    height: "3.8em",
    maxWidth: "3",
    maxHeight: "74px",
    marginBottom: ".7em;",
    background:
      "linear-gradient(-135deg, rgb(66, 129, 255) 0%, rgb(117, 117, 255) 100%)",
    borderRadius: 0,
    boxShadow: "none",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    letterSpacing: "-0.5px"
  },
  actions_link: {
    textDecoration: "none",
    color: "rgb(66, 129, 255)",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    height: "34px",
    letterSpacing: "-0.5px",
    textAlign: "center",
    width: "269.88px",
    marginTop: ".7em"
  }
};

export default styles;
